const actions = {
  
  PRICING_PLANS_READ_BEGIN: 'PRICING_PLANS_READ_BEGIN',
  PRICING_PLANS_READ_SUCCESS: 'PRICING_PLANS_READ_SUCCESS',
  PRICING_PLANS_READ_ERR: 'PRICING_PLANS_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.PRICING_PLANS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.PRICING_PLANS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.PRICING_PLANS_READ_ERR,
      err,
    };
  },

};

export default actions;
